import { useGetUsersQuery } from "../usersSlice";
import useHasAccess from "../../../hooks/useHasAccess";
import useRefresher from "../../../hooks/useRefresher";

const useUsers = () => {
  const hasAccess = useHasAccess({ apiCall: "users.GET" });
  const users = useGetUsersQuery(null, { skip: !hasAccess });
  useRefresher(users);

  return { ...users, hasAccess };
};

export default useUsers;
